import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

type CounterProps = {
  end: number;
  suffix?: string; 
  duration?: number;
};

const Counter: React.FC<CounterProps> = ({ end, suffix = "", duration = 3 }) => {
  const { ref, inView } = useInView({
    triggerOnce: false, 
    threshold: 0.3,
  });

  const [counterKey, setCounterKey] = useState(0);

  useEffect(() => {
    if (inView) {
      setCounterKey((prev) => prev + 1);
    }
  }, [inView]);

  return (
    <span ref={ref}>
      <CountUp key={counterKey} start={0} end={end} duration={duration} suffix={suffix} decimals={end % 1 !== 0 ? 1 : 0} />
    </span>
  );
};

export default Counter;
